import { SofiaEnvironment } from "@/sofia-environment"

const {
  Bff: { Url: bffHost, Credentials: credentials },
} = SofiaEnvironment

function hinLogin() {
  window.open(`${bffHost}/bff/hin-sign-login?returnUrl=/hin-sign-logged-in`)
}

const hinLogout = async () => {
  const response = await fetch(`${bffHost}/bff/hin-sign-logout`, {
    method: "DELETE",
    credentials: credentials,
  })

  if (!response.ok) {
    throw new Error("Failed to logout for HIN Sign")
  }
}

const hinCheckValidity = async () => {
  const response = await fetch(`${bffHost}/bff/hin-sign-silent-login`, {
    method: "GET",
    credentials: credentials,
  })

  return response.status === 200
}

export { hinLogin, hinLogout, hinCheckValidity }
